<template>
  <div class="table-expand">
    <component
      v-if="!tableData.custom"
      :is="tableData.tagName"
      :scope="scope"
      :tableData="tableData"
      v-bind="$attrs"
    ></component>
    <component
      v-else
      :is="tableData.tagName"
      :scope="scope"
      :data="scope.row[tableData.bind]"
      v-bind="tableData"
      :tableData="tableData"
    ></component>
  </div>
</template>
<script>
import filters from '@/mixins/filters'
import skyCard from '@/components/iglobalwin/formComponents/sky-card.vue'
export default {
  name: 'table-expand',
  props: ['tableData', 'scope'],
  methods: {
    bind() {
      let { scope, tableData } = this
      if (tableData.childEvent) {
        return tableData.childEvent(scope, tableData)
      }
      return {}
    },
  },
  components: {
    skyCard,
  },
  mixins: [filters],
  data() {
    return {}
  },
  mounted() {},
}
</script>
<style></style>
